import classNames from 'classnames';
function TableHeader({ children, classname }) {
  const classes = classNames('select-none overflow-hidden w-full', classname);
  return <div className={classes}>{children}</div>;
}

export default TableHeader;
